import React, { useState } from 'react';
import { Space, Typography } from 'antd';

import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import BreadcrumbContainer from '../../containers/Breadcrumb';

import { finishedAjaxTable as filterAnnouncements } from '../../api/module/announcement';
import AjaxTable from '../../components/AjaxTable';
import { CustomTooltip, IconButton } from '../../components';
import { EyeOutlined, MessageFilled, TagsFilled } from '@ant-design/icons';

const { Title } = Typography;

const breadcrumbItems = [
  {
    text: 'Convocatoria',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
  },
  {
    text: 'Histórico de convocatorias',
  },
];

const AnnouncementHistoryList = ({ history }) => {
  const [sortColumn, setSortColumn] = useState('-created_at');
  const columns = [
    {
      title: (
        <>
          Tipo
          <CustomTooltip
            title={
              <p>
                Convocatoria <br />
                A: Abierta
                <br />
                C: Cerrada
              </p>
            }
          />
        </>
      ),
      dataIndex: 'tipo_convocatoria',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('tipo_convocatoria');
        if (sortOrder === 'descend') setSortColumn('-tipo_convocatoria');
      },
    },
    {
      title: 'Proyecto',
      dataIndex: 'nombre_proyecto',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('nombre_proyecto');
        if (sortOrder === 'descend') setSortColumn('-nombre_proyecto');
      },
    },
    {
      title: 'Organización',
      dataIndex: 'organizacion_nombre',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('organizacion_nombre');
        if (sortOrder === 'descend') setSortColumn('-organizacion_nombre');
      },
    },
    {
      title: 'Aliado',
      dataIndex: 'aliado_nombre',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('aliado_nombre');
        if (sortOrder === 'descend') setSortColumn('-aliado_nombre');
      },
    },
    {
      title: 'No. conv',
      dataIndex: 'numero',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('created_at');
        if (sortOrder === 'descend') setSortColumn('-created_at');
      },
    },
    {
      title: 'Nombre convocatoria',
      dataIndex: 'nombre',
      width: '20em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('nombre');
        if (sortOrder === 'descend') setSortColumn('-nombre');
      },
    },
    {
      title: 'Fecha inicio',
      dataIndex: 'fecha_inicio',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('fecha_inicio');
        if (sortOrder === 'descend') setSortColumn('-fecha_inicio');
      },
    },
    {
      title: 'Fecha fin',
      dataIndex: 'fecha_fin',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('fecha_fin');
        if (sortOrder === 'descend') setSortColumn('-fecha_fin');
      },
    },
    {
      title: '# Cargo / Rol',
      dataIndex: 'num_cargos',
      align: 'center',
      width: '5em',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('num_cargos');
        if (sortOrder === 'descend') setSortColumn('-num_cargos');
      },
    },
    {
      title: 'Estado',
      dataIndex: 'estado_convocatoria_texto',
      width: '10em',
      align: 'center',
      sorter: (a, b, sortOrder) => {
        if (sortOrder === 'ascend') setSortColumn('estado_convocatoria_texto');
        if (sortOrder === 'descend')
          setSortColumn('-estado_convocatoria_texto');
      },
    },
    {
      title: 'Acciones',
      key: 'accion',
      fixed: 'right',
      width: 140,
      align: 'center',
      render: (_, record) => (
        <Space>
          <IconButton
            title="Ver"
            bordered
            color="blue"
            linkTo={`${INTERNAL_LINKS.ANNOUNCEMENT_SHOW}/${record.id}/?history=true`}
            icon={<EyeOutlined />}
          />
          <IconButton
            title="Detalle"
            bordered
            color="bigaro"
            linkTo={`${INTERNAL_LINKS.ANNOUNCEMENT_DETAILS}/${record.id}`}
            icon={<TagsFilled />}
          />
          <IconButton
            title="Ver motivo"
            bordered
            color="lime"
            icon={<MessageFilled />}
          />
        </Space>
      ),
    },
  ];

  const back = () => {
    history.goBack();
  };

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Histórico de convocatorias
      </Title>
      <AjaxTable
        columns={columns}
        pageSize={10}
        sortBy={sortColumn}
        searchInput
        exportCSV
        reloadButton
        tableTitle={'Listado de convocatorias finalizadas'}
        endpoint={filterAnnouncements}
      />
      <CustomButton
        type={'default'}
        className={'back-button'}
        htmlType="button"
        onClick={() => back()}
        text="Volver"
      />
    </>
  );
};

export default AnnouncementHistoryList;
